export default "__VITE_ASSET__BcaoHexe__"